// @flow

export function capitalize(aString: string) {
	return aString.charAt(0).toUpperCase() + aString.slice(1);
}
